import { UserAuthService } from '../../services/user-auth.service';
import {
	Component,
	OnInit,
	Output,
	EventEmitter,
	Input
} from '@angular/core';
import { User } from '../../../core/models/user.model';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../services/auth.service';
import { Utils } from 'src/app/shared/utils/utils';
import { MDM_ADMINS_ROLES } from '../../constants/roles.constant';


@Component({
	selector: 'ag-top-toolbar',
	templateUrl: './top-toolbar.component.html',
	styleUrls: ['./top-toolbar.component.scss'],
	standalone: false
})
export class TopToolbarComponent implements OnInit {
	@Input() showMenuDesktop = false;
	@Input() type = 'user';
	@Output() toggleMenu: EventEmitter<boolean> = new EventEmitter<boolean>(
		false
	);
	toggled: boolean = false;
	isMobile: boolean = false;
	public user: User;
	public heroImage = environment.baseHref + 'assets/images/hero/user.png';

	public readonly MDM_ADMINS = MDM_ADMINS_ROLES;

	constructor(
		private readonly userAuthService: UserAuthService,
		private readonly authService: AuthService
	) { }

	ngOnInit(): void {
		this.userAuthService.getUserDetails().then(user => {
			this.user = user;
		});
	}

	toggle() {
		this.toggled = !this.toggled;
		this.toggleMenu.emit(this.toggled);
	}

	getProfilePhoto() {
		return this.user?.image ?? this.heroImage;
	}

	onImageError(event: Event) {
		const target = event.target as HTMLImageElement;
		target.src = this.heroImage;
	}

	logout() {
		this.userAuthService.clearUserDetails();
		this.authService.logout();
	}
}
